<template>
   <div class="layout-page">
      <h1>Frequently Asked Questions</h1>

      <h3 class="ml-purple mart-24">HOW DO I RECRUIT?</h3>
      <p>
         Check out this document which gives details on how to invite people to get appointed into your downline:
      </p>
      <p class="marl-12">
         <a href="#" @click.prevent="doc('HowToRecruit.pdf','HowToRecruit.pdf')">
            <i class="fas fa-file-pdf"></i>
            HowToRecruit.pdf
         </a>
      </p>

      <h3 class="ml-purple mart-24">HOW DO I COMPLETE APPOINTMENT APPLICATIONS FOR PROSPECT AGENTS?</h3>
      <p>
         Check out this document which gives details on how to complete appointment applications for prospect agents:
      </p>
      <p class="marl-12">
         <a href="#" @click.prevent="doc('CompAppForAgent.pdf','CompAppForAgent.pdf')">
            <i class="fas fa-file-pdf"></i>
            CompAppForAgent.pdf
         </a>
      </p>          

      <h3 class="ml-purple mart-24">NEED CUSTOMER SERVICE?</h3>
      <p>
         For any questions please contact the Marketing Department at 888-441-0770 or email us at <a :href="mktMail">Marketing</a>.
      </p>

      <br>
      <br>
      <br>      
   </div>
</template>

<script>
export default {
   name: 'FAQ',
   data() {
      return {
         mktMail: `mailto:${process.env.VUE_APP_MKT_EMAIL}`
      };
   },
   methods: {
      doc(path,title) {
         let payload = {
            AppUserId: this.appUserId,
            DownloadFileType: 4, // CorpDoc
            Path: path,
            Title: title
         };

         this.$swal({
            title: "Download Initiated",
            html: "Please wait...",
            timer: 1000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
            willOpen: () => {
               this.$swal.showLoading();
            },
            willClose: () => {},
         });

         this.$document.apiDownload(payload).then(
            (r) => {
               if (this.$document.errors.length > 0) {
                  this.$swal(
                     "Document Unavailable",
                     "Unfortunately we are having trouble downloading your document at this time. " + this.$document.errors[0],
                     "error"
                  );
               } 
            },
            (e) => {
               this.$swal(
                  "Document Unavailable",
                  "Unfortunately we are having trouble downloading your document at this time. Please try again later or contact us if this problem persists.",
                  "error"
               );
            }
         )
      }
   },
};
</script>

<style scoped>
#tslink:visited {
   color: #fff;
}
</style>